function TodosEmpty(){
    return(
        <p>Carga tu primera tarea</p>
    )
}
export {TodosEmpty}